import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
//Utils 
import { checkUserPermission } from '../../utils/CheckUserPermitions';
import { RenderIf } from '../../utils/RenderIf';

import ModalSetting from '../../Modals/SettingsPos/ModalSetting';
import ModalNotification from '../ModalNotification';
//Api 
import { MachinesFetchAPI } from '../../../api/Machines';

import ErrorAlert from '../../Alerts/ErrorAlert';

const NavBar = ({ setPageLoader, codeParthner }) => {
   //Params 
   const navigate = useNavigate();
   let { business_code, branchoffice_code } = useParams();
   let user = localStorage.getItem('user');
   let token = localStorage.getItem('x-access-machine-token');
   let branchoffice = localStorage.getItem('branchoffice');
   let user_token = localStorage.getItem('x-access-token');
   const [showModalSetting, setshowModalSetting] = useState(false)
   //Location page 
   const url_path = useLocation();
   if (localStorage.getItem("x-access-machine-token") == "") {
      let business = JSON.parse(localStorage.getItem("business"))
      //navigate(`/machines/login/`+business.code)
      window.location.href = '/machines/login/' + business.code;
      console.log("hello");
   }

   //console.log('user:', user)

   //We validate if the user is logged in
   if (user === null || user === undefined || user === '' || user === 'null') {
      user = {
         name: 'No registrado',
         img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
      }
   } else {
      user = JSON.parse(localStorage.getItem('user'));
   }

   //We validate if the branch
   if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
      branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
   }

   //Function to logout of the payment post
   const signout = async () => {
      let machine_token = localStorage.getItem('x-access-machine-token');
      let machine = JSON.parse(localStorage.getItem('machine_original'));

      if (!machine || !machine.code) {
         ErrorAlert("No se encontró información de la máquina", "No se puede cerrar sesión correctamente", "error");
         return;
      }

      let liberada = false;
      let errorMsg = '';
      try {
         const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
         if (response.data && response.data.success === true) {
            liberada = true;
         } else {
            errorMsg = response.data && response.data.error ? response.data.error : 'No se pudo liberar la máquina.';
         }
      } catch (err) {
         errorMsg = err?.response?.data?.error || err?.message || 'Error de red al liberar la máquina.';
      }

      if (liberada) {
         localStorage.clear();
         navigate(`/machines/login/${business_code}`);
      } else {
         ErrorAlert("No se pudo liberar la máquina", errorMsg + "\nIntente nuevamente. Si el problema persiste, contacte a soporte.", "error");
      }
   }



   useEffect(() => {
      //We check the data on the local storage 
      if (!url_path.pathname.includes('preaccount') && (user === '' || user === null || user === undefined || token === '' || branchoffice === '' || token === null || branchoffice === null || token === undefined || branchoffice === undefined || user_token === 'undefined' || user_token === 'null' || user_token === '' || user_token === null || user_token === undefined)) {
         navigate(`/machines/login/${business_code}`);
      }
   }, []);

   const [isVisible, setIsVisible] = useState(false);
   const buttonRef = useRef(null);
   const toggleVisibility = () => {
      setIsVisible(!isVisible);
   };

   const calculateDropdownPosition = () => {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      return {
         top: buttonRect.top + buttonRect.height,
         left: buttonRect.left,
      };
   };

   return (
      <>



         {/* 
            <ModalNotification></ModalNotification> */}



         <Link className="dropdown-item" to={`/payments/${business_code}/${branchoffice_code}`}>
            <button className="spn-item" type="button"           >
               <span className="spn-item__ic">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                     <rect x="5" y="2" width="14" height="20" rx="2.5" />
                     <rect x="8" y="5" width="8" height="5" rx="1" />
                     <line x1="8" y1="13.5" x2="9.5" y2="13.5" />
                     <line x1="11.25" y1="13.5" x2="12.75" y2="13.5" />
                     <line x1="14.5" y1="13.5" x2="16" y2="13.5" />
                     <line x1="8" y1="16.5" x2="9.5" y2="16.5" />
                     <line x1="11.25" y1="16.5" x2="12.75" y2="16.5" />
                     <line x1="14.5" y1="16.5" x2="16" y2="16.5" />
                     <line x1="8" y1="19.5" x2="9.5" y2="19.5" />
                     <line x1="11.25" y1="19.5" x2="12.75" y2="19.5" />
                     <rect x="13.5" y="19" width="2.5" height="1.2" rx="0.4" />
                  </svg>               </span>


               <span className="spn-item__label">Caja de Pago </span>
            </button>
         </Link>

         <RenderIf isTrue={checkUserPermission("daily_pos_user_report", user.permissions) !== -1}>
            <Link className="dropdown-item" to={`/payment/report/${business_code}/${branchoffice_code}`}>
               <button className="spn-item" type="button"           >
                  <span className="spn-item__ic">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                        <path d="M3 3v18h18" />
                        <rect x="7" y="12" width="3" height="6" rx="0.6" />
                        <rect x="12" y="8" width="3" height="10" rx="0.6" />
                        <rect x="17" y="5" width="3" height="13" rx="0.6" />
                     </svg>                  </span>
                  <span className="spn-item__label">Reportes </span>
               </button>
            </Link>
         </RenderIf>

         <RenderIf isTrue={checkUserPermission("daily_pos_user_report", user.permissions) !== -1}>
            <Link className="dropdown-item" to={`/payment/report/${business_code}/${branchoffice_code}`}>
               <button className="spn-item" type="button"           >
                  <span className="spn-item__ic">
                     <i className="uil uil-clipboard"></i>
                  </span>
                  <span className="spn-item__label">Historial de cierres </span>
               </button>
            </Link>
         </RenderIf>

         <RenderIf isTrue={checkUserPermission("delivery_module", user.permissions) !== -1}>
            <Link className="dropdown-item" to={`/payment/${business_code}/${branchoffice_code}/delivery`}>
               <button className="spn-item" type="button"           >
                  <span className="spn-item__ic">
                     <i className="uil uil-location-arrow-alt"></i>
                  </span>
                  <span className="spn-item__label">  Delivery </span>
               </button>
            </Link>

         </RenderIf >




      </>
   )
}

export default NavBar